// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zAgentCommand = z.object({
    id: z.string(),
    type: z.enum(['refresh_now', 'full_now']),
    payload: z.unknown()
});

export const zInstant = z.string();

export const zAgentManifestTableConfirmed = z.object({
    tableName: z.string().min(1).max(128),
    outcome: z.enum([
        'stored',
        'already_present',
        'unchanged'
    ]),
    sha256: z.string().regex(/^[0-9a-f]{64}$/),
    sourceMtime: z.optional(zInstant)
});

export const zAgentManifestTableFailed = z.object({
    tableName: z.string().min(1).max(128),
    outcome: z.enum(['failed']),
    sha256: z.optional(z.string().regex(/^[0-9a-f]{64}$/)),
    sourceMtime: z.optional(zInstant),
    reason: z.string().min(1).max(1000)
});

export const zAgentManifestTable = z.union([
    z.object({
        outcome: z.union([
            z.literal('stored'),
            z.literal('already_present'),
            z.literal('unchanged')
        ])
    }).and(zAgentManifestTableConfirmed),
    z.object({
        outcome: z.literal('failed')
    }).and(zAgentManifestTableFailed)
]);

export const zBackupStored = z.object({
    status: z.enum(['stored']),
    backupId: z.string(),
    schemaChanged: z.boolean(),
    commands: z.array(zAgentCommand)
});

export const zBackupAlreadyPresent = z.object({
    status: z.enum(['already_present']),
    backupId: z.string(),
    commands: z.array(zAgentCommand)
});

export const zBackupRejected = z.object({
    status: z.enum(['rejected']),
    reason: z.string(),
    commands: z.array(zAgentCommand)
});

export const zAppConfigStatus = z.object({
    status: z.enum(['ok', 'maintenance']),
    maintenance: z.union([
        z.object({
            enabled: z.boolean(),
            message: z.union([
                z.string(),
                z.null()
            ]),
            retryAfterSeconds: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ])
        }),
        z.null()
    ])
});

export const zInstantOutput = z.string();

export const zBackofficeAdminIdentity = z.object({
    id: z.string()
});

export const zOtpIssuanceThrottled = z.object({
    code: z.enum(['otp_issuance_throttled']),
    message: z.string(),
    retryAfterSeconds: z.int().gt(0).lte(9007199254740991)
});

export const zBackofficeRateLimited = z.object({
    code: z.enum(['backoffice_rate_limited']),
    message: z.string(),
    retryAfterSeconds: z.int().gt(0).lte(9007199254740991)
});

export const zPassword = z.string();

export const zBackofficeChangePasswordCurrentPasswordPayload = z.object({
    type: z.enum(['current-password']),
    currentPassword: z.string().min(1),
    newPassword: zPassword,
    revokeOtherSessions: z.optional(z.boolean()).default(true)
});

export const zBackofficeChangePasswordOtpPayload = z.object({
    type: z.enum(['otp']),
    code: z.string(),
    emailOtpToken: z.string(),
    newPassword: zPassword,
    revokeOtherSessions: z.optional(z.boolean()).default(true)
});

export const zBackofficeInvalidPassword = z.object({
    code: z.enum(['backoffice_invalid_password']),
    message: z.string()
});

export const zBackofficeChangePasswordOtpInvalid = z.object({
    code: z.enum(['backoffice_change_password_otp_invalid']),
    message: z.string()
});

export const zBackofficeNoChangePasswordMethodAvailable = z.object({
    code: z.enum(['backoffice_no_change_password_method_available']),
    message: z.string()
});

export const zBackofficeAuthCredentialsMissing = z.object({
    code: z.enum(['backoffice_auth_credentials_missing']),
    message: z.string()
});

export const zBackofficeJwtInvalid = z.object({
    code: z.enum(['backoffice_jwt_invalid']),
    message: z.string()
});

export const zBackofficeSessionInvalid = z.object({
    code: z.enum(['backoffice_session_invalid']),
    message: z.string()
});

export const zBackofficeSessionExpired = z.object({
    code: z.enum(['backoffice_session_expired']),
    message: z.string()
});

export const zBackofficeAdminDeleted = z.object({
    code: z.enum(['backoffice_admin_deleted']),
    message: z.string()
});

export const zBackofficeEmailOtpTokenInvalid = z.object({
    code: z.enum(['backoffice_email_otp_token_invalid']),
    message: z.string()
});

export const zBackofficeAdminStatus = z.enum(['pending', 'active']);

export const zBackofficeAdmin = z.object({
    id: z.string(),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    name: z.union([
        z.string(),
        z.null()
    ]),
    emailVerifiedAt: z.union([
        z.string(),
        z.null()
    ]),
    status: zBackofficeAdminStatus,
    abilities: z.array(z.enum(['admins.manage'])),
    createdAt: zInstantOutput
});

export const zOffsetPaginationMeta = z.object({
    page: z.number(),
    limit: z.number(),
    total: z.number(),
    totalPages: z.number()
});

export const zBackofficeCsrfInvalid = z.object({
    code: z.enum(['backoffice_csrf_invalid']),
    message: z.string()
});

export const zAdminForbidden = z.object({
    code: z.enum(['admin_forbidden']),
    message: z.string()
});

export const zBackofficeSelfEditForbidden = z.object({
    code: z.enum(['backoffice_self_edit_forbidden']),
    message: z.string()
});

export const zBackofficeAdminProfile = z.object({
    id: z.string(),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    name: z.union([
        z.string(),
        z.null()
    ])
});

export const zBackofficeGetSessionSessionBlock = z.object({
    expiresAt: zInstantOutput,
    lastActivityAt: zInstantOutput,
    creationSource: z.string()
});

export const zDatasetTableBehind = z.object({
    tableName: z.string(),
    confirmedAt: zInstantOutput
});

export const zPoRun = z.object({
    id: z.string(),
    name: z.string(),
    campaign: z.int().gte(-9007199254740991).lte(9007199254740991),
    mode: z.enum(['campagna', 'riordino']),
    horizonDays: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    zeroStock: z.boolean(),
    distributorNames: z.union([
        z.array(z.string()),
        z.null()
    ]),
    status: z.enum([
        'pending',
        'running',
        'failed',
        'in_progress',
        'completed',
        'archived'
    ]),
    engineVersion: z.union([
        z.string(),
        z.null()
    ]),
    error: z.union([
        z.string(),
        z.null()
    ]),
    totalRows: z.int().gte(-9007199254740991).lte(9007199254740991),
    orderedRows: z.int().gte(-9007199254740991).lte(9007199254740991),
    totalCopies: z.int().gte(-9007199254740991).lte(9007199254740991),
    reviewedRows: z.int().gte(-9007199254740991).lte(9007199254740991),
    flaggedRows: z.int().gte(-9007199254740991).lte(9007199254740991),
    adottatoLoaded: z.union([
        z.boolean(),
        z.null()
    ]),
    segnaliAssenti: z.union([
        z.array(z.string()),
        z.null()
    ]),
    datasetAsOf: z.union([
        z.string(),
        z.null()
    ]),
    tablesBehind: z.union([
        z.array(zDatasetTableBehind),
        z.null()
    ]),
    startedAt: z.union([
        z.string(),
        z.null()
    ]),
    finishedAt: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: zInstantOutput,
    updatedAt: zInstantOutput
});

export const zPoPublisherTab = z.object({
    publisherId: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    publisherName: z.union([
        z.string(),
        z.null()
    ]),
    rows: z.int().gte(-9007199254740991).lte(9007199254740991),
    copies: z.int().gte(-9007199254740991).lte(9007199254740991),
    ordered: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zPoDistributorTab = z.object({
    distributorName: z.union([
        z.string(),
        z.null()
    ]),
    rows: z.int().gte(-9007199254740991).lte(9007199254740991),
    copies: z.int().gte(-9007199254740991).lte(9007199254740991),
    ordered: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zPoProposalGridRow = z.object({
    id: z.string(),
    runId: z.string(),
    campaign: z.int().gte(-9007199254740991).lte(9007199254740991),
    libro: z.int().gte(-9007199254740991).lte(9007199254740991),
    bookCode: z.union([
        z.string(),
        z.null()
    ]),
    title: z.union([
        z.string(),
        z.null()
    ]),
    isbn: z.union([
        z.string(),
        z.null()
    ]),
    publisherId: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    publisherName: z.union([
        z.string(),
        z.null()
    ]),
    distributorName: z.union([
        z.string(),
        z.null()
    ]),
    schoolType: z.string(),
    proposedQty: z.int().gte(-9007199254740991).lte(9007199254740991),
    reasoning: z.string(),
    flag: z.string(),
    forecast: z.int().gte(-9007199254740991).lte(9007199254740991),
    soldPrevYear: z.int().gte(-9007199254740991).lte(9007199254740991),
    soldYtd: z.int().gte(-9007199254740991).lte(9007199254740991),
    predSoldPrevYear: z.int().gte(-9007199254740991).lte(9007199254740991),
    predSoldYtd: z.int().gte(-9007199254740991).lte(9007199254740991),
    stock: z.int().gte(-9007199254740991).lte(9007199254740991),
    committed: z.int().gte(-9007199254740991).lte(9007199254740991),
    orderedYtd: z.int().gte(-9007199254740991).lte(9007199254740991),
    orderValue: z.number(),
    reviewStatus: z.enum([
        'pending',
        'accepted',
        'corrected'
    ]),
    correctedQty: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    feedbackNote: z.union([
        z.string(),
        z.null()
    ]),
    reviewedAt: z.union([
        z.string(),
        z.null()
    ]),
    details: z.union([
        z.object({
            sezTgt: z.optional(z.union([
                z.number(),
                z.null()
            ])),
            sezPrev: z.optional(z.union([
                z.number(),
                z.null()
            ])),
            venduto2: z.optional(z.union([
                z.number(),
                z.null()
            ])),
            venduto3: z.optional(z.union([
                z.number(),
                z.null()
            ])),
            predVenduto2: z.optional(z.union([
                z.number(),
                z.null()
            ])),
            predVenduto3: z.optional(z.union([
                z.number(),
                z.null()
            ])),
            riforn: z.optional(z.union([
                z.number(),
                z.null()
            ])),
            disponibile: z.optional(z.union([
                z.number(),
                z.null()
            ])),
            breakdown: z.optional(z.union([
                z.object({
                    adoption: z.optional(z.union([
                        z.object({
                            regions: z.array(z.object({
                                region: z.string(),
                                sezioni: z.number()
                            }))
                        }),
                        z.null()
                    ]))
                }),
                z.null()
            ]))
        }),
        z.null()
    ])
});

export const zPoProposalGridDetails = z.object({
    sezTgt: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    sezPrev: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    venduto2: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    venduto3: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    predVenduto2: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    predVenduto3: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    riforn: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    disponibile: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    breakdown: z.optional(z.union([
        z.object({
            adoption: z.optional(z.union([
                z.object({
                    regions: z.array(z.object({
                        region: z.string(),
                        sezioni: z.number()
                    }))
                }),
                z.null()
            ]))
        }),
        z.null()
    ]))
});

export const zPoPastDecision = z.object({
    runId: z.string(),
    runName: z.string(),
    campaign: z.int().gte(-9007199254740991).lte(9007199254740991),
    proposedQty: z.int().gte(-9007199254740991).lte(9007199254740991),
    correctedQty: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    reviewStatus: z.enum([
        'pending',
        'accepted',
        'corrected'
    ]),
    feedbackNote: z.union([
        z.string(),
        z.null()
    ])
});

export const zPoProposal = z.object({
    id: z.string(),
    runId: z.string(),
    campaign: z.int().gte(-9007199254740991).lte(9007199254740991),
    libro: z.int().gte(-9007199254740991).lte(9007199254740991),
    bookCode: z.union([
        z.string(),
        z.null()
    ]),
    title: z.union([
        z.string(),
        z.null()
    ]),
    isbn: z.union([
        z.string(),
        z.null()
    ]),
    publisherId: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    publisherName: z.union([
        z.string(),
        z.null()
    ]),
    distributorName: z.union([
        z.string(),
        z.null()
    ]),
    schoolType: z.string(),
    proposedQty: z.int().gte(-9007199254740991).lte(9007199254740991),
    reasoning: z.string(),
    flag: z.string(),
    forecast: z.int().gte(-9007199254740991).lte(9007199254740991),
    soldPrevYear: z.int().gte(-9007199254740991).lte(9007199254740991),
    soldYtd: z.int().gte(-9007199254740991).lte(9007199254740991),
    predSoldPrevYear: z.int().gte(-9007199254740991).lte(9007199254740991),
    predSoldYtd: z.int().gte(-9007199254740991).lte(9007199254740991),
    stock: z.int().gte(-9007199254740991).lte(9007199254740991),
    committed: z.int().gte(-9007199254740991).lte(9007199254740991),
    orderedYtd: z.int().gte(-9007199254740991).lte(9007199254740991),
    orderValue: z.number(),
    reviewStatus: z.enum([
        'pending',
        'accepted',
        'corrected'
    ]),
    correctedQty: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    feedbackNote: z.union([
        z.string(),
        z.null()
    ]),
    reviewedAt: z.union([
        z.string(),
        z.null()
    ]),
    details: z.unknown()
});

export const zPoProposalViewFilters = z.object({
    publisherIds: z.optional(z.array(z.int().gte(-2147483648).lte(2147483647)).max(100)),
    distributorNames: z.optional(z.array(z.string()).max(100)),
    schoolTypes: z.optional(z.array(z.enum([
        'elementari',
        'medie',
        'superiori',
        'varia'
    ])).max(10)),
    flags: z.optional(z.array(z.enum([
        'VERIFICA_EDIZIONE',
        'ESCLUSIVA_PERSA',
        'ESCLUSIVA_ACQUISITA',
        'SCORRIMENTO',
        'ADOTTATO',
        'EDIZIONE_RECENTE',
        'COPERTO',
        'EDIZIONE_DOPPIA',
        'CAPO_CICLO',
        'PRIMO_VOLUME',
        'NON_USCITO',
        ''
    ])).max(20)),
    reviewStatus: z.optional(z.array(z.enum([
        'pending',
        'accepted',
        'corrected'
    ])).max(10)),
    search: z.optional(z.string().max(200)),
    onlyOrdered: z.optional(z.boolean())
});

export const zPoAuditEvent = z.object({
    id: z.string(),
    action: z.string(),
    oldValue: z.unknown(),
    newValue: z.unknown(),
    actorId: z.string(),
    createdAt: zInstantOutput
});

export const zPoExport = z.object({
    id: z.string(),
    runId: z.string(),
    runName: z.string(),
    status: z.enum([
        'pending',
        'completed',
        'failed'
    ]),
    summary: z.unknown(),
    error: z.union([
        z.string(),
        z.null()
    ]),
    generatedAt: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: zInstantOutput
});

export const zExclusivityPublisher = z.object({
    name: z.string().min(1).max(256),
    regions: z.array(z.enum([
        'LAZIO',
        'CAMPANIA',
        'SICILIA',
        'PUGLIA',
        'TOSCANA',
        'CALABRIA',
        'SARDEGNA',
        'ABRUZZO',
        'UMBRIA',
        'BASILICATA',
        'MOLISE'
    ])).max(11),
    returnPct: z.union([
        z.number().gte(0).lte(1),
        z.null()
    ])
});

export const zExclusivitySnapshot = z.object({
    year: z.int().gte(1900).lte(9999),
    publishers: z.array(zExclusivityPublisher).max(10000)
});

export const zPoConfigHistoryEntry = z.object({
    id: z.string(),
    createdAt: zInstantOutput,
    changedBy: z.union([
        z.object({
            id: z.string(),
            name: z.union([
                z.string(),
                z.null()
            ]),
            email: z.union([
                z.string(),
                z.null()
            ])
        }),
        z.null()
    ])
});

export const zPoConfigAuthor = z.object({
    id: z.string(),
    name: z.union([
        z.string(),
        z.null()
    ]),
    email: z.union([
        z.string(),
        z.null()
    ])
});

export const zDocsSchemaData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zAgentHeartbeatData = z.object({
    body: z.object({
        agentVersion: z.optional(z.string()),
        hostname: z.optional(z.string()),
        acknowledgements: z.optional(z.array(z.object({
            id: z.string(),
            result: z.optional(z.string())
        })).max(100))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAgentHeartbeatResponse = z.object({
    status: z.enum(['success']),
    commands: z.array(zAgentCommand)
});

export const zAgentManifestData = z.object({
    body: z.object({
        clientRoundId: z.string().min(1).max(64),
        tables: z.array(zAgentManifestTable).min(1).max(100),
        agentVersion: z.optional(z.string()),
        hostname: z.optional(z.string()),
        acknowledgements: z.optional(z.array(z.object({
            id: z.string(),
            result: z.optional(z.string())
        })).max(100))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAgentManifestResponse = z.object({
    status: z.enum(['success']),
    roundId: z.string(),
    commands: z.array(zAgentCommand)
});

export const zAgentBackupData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAgentBackupResponse = z.union([
    z.object({
        status: z.literal('stored')
    }).and(zBackupStored),
    z.object({
        status: z.literal('already_present')
    }).and(zBackupAlreadyPresent),
    z.object({
        status: z.literal('rejected')
    }).and(zBackupRejected)
]);

export const zAppConfigGetStatusData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAppConfigGetStatusResponse = z.object({
    data: zAppConfigStatus
});

export const zBackofficeAuthSignInWithEmailData = z.object({
    body: z.object({
        email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        password: z.string().min(1)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthSignInWithEmailResponse = z.object({
    status: z.enum(['success']),
    token: z.string(),
    csrfToken: z.string(),
    expiresAt: zInstantOutput,
    admin: zBackofficeAdminIdentity,
    abilities: z.array(z.enum(['admins.manage']))
});

export const zBackofficeAuthRequestPasswordResetData = z.object({
    body: z.object({
        type: z.enum(['magic-link']),
        email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthRequestPasswordResetResponse = z.object({
    status: z.enum(['success'])
});

export const zBackofficeAuthResetPasswordData = z.object({
    body: z.object({
        type: z.enum(['magic-link']),
        value: z.string().min(1),
        newPassword: zPassword,
        revokeOtherSessions: z.optional(z.boolean()).default(true)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthResetPasswordResponse = z.object({
    status: z.enum(['success']),
    token: z.string(),
    csrfToken: z.string(),
    expiresAt: zInstantOutput,
    admin: zBackofficeAdminIdentity,
    abilities: z.array(z.enum(['admins.manage']))
});

export const zBackofficeAuthChangePasswordData = z.object({
    body: z.union([
        z.object({
            type: z.literal('current-password')
        }).and(zBackofficeChangePasswordCurrentPasswordPayload),
        z.object({
            type: z.literal('otp')
        }).and(zBackofficeChangePasswordOtpPayload)
    ]),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthChangePasswordResponse = z.object({
    status: z.enum(['success'])
});

export const zBackofficeAuthSendChangePasswordOtpData = z.object({
    body: z.record(z.string(), z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthSendChangePasswordOtpResponse = z.object({
    status: z.enum(['success']),
    emailOtpToken: z.string()
});

export const zBackofficeAuthCreateAdminData = z.object({
    body: z.object({
        data: z.object({
            email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
            name: z.optional(z.string().min(1).max(100)),
            abilities: z.array(z.enum(['admins.manage'])).max(10),
            language: z.optional(z.enum(['en', 'it']))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthCreateAdminResponse = z.object({
    data: zBackofficeAdmin
});

export const zBackofficeAuthAcceptInviteData = z.object({
    body: z.object({
        token: z.string().min(1),
        password: zPassword,
        name: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthAcceptInviteResponse = z.object({
    status: z.enum(['success']),
    token: z.string(),
    csrfToken: z.string(),
    expiresAt: zInstantOutput,
    admin: zBackofficeAdminIdentity,
    abilities: z.array(z.enum(['admins.manage']))
});

export const zBackofficeAuthResendInviteData = z.object({
    body: z.object({
        adminId: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthResendInviteResponse = z.object({
    status: z.enum(['success'])
});

export const zBackofficeAuthListAdminsData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.optional(z.object({
            ids: z.optional(z.union([
                z.array(z.string()).min(1).max(100),
                z.null()
            ])),
            search: z.optional(z.union([
                z.string().min(1),
                z.null()
            ])),
            abilities: z.optional(z.array(z.enum(['admins.manage'])).min(1).max(10)),
            status: z.optional(z.nullable(z.enum(['pending', 'active'])))
        })),
        sort: z.optional(z.object({
            by: z.optional(z.enum(['createdAt', 'name'])),
            direction: z.optional(z.enum(['asc', 'desc']))
        })).default({ by: 'createdAt', direction: 'desc' })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthListAdminsResponse = z.object({
    data: z.array(zBackofficeAdmin),
    meta: zOffsetPaginationMeta
});

export const zBackofficeAuthUpdateAdminAbilitiesData = z.object({
    body: z.object({
        data: z.object({
            id: z.string(),
            abilities: z.array(z.enum(['admins.manage'])).max(10)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthUpdateAdminAbilitiesResponse = z.object({
    data: zBackofficeAdmin
});

export const zBackofficeAuthDeleteAdminData = z.object({
    body: z.object({
        ids: z.array(z.string()).min(1).max(100)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zBackofficeAuthGetMeData = z.object({
    body: z.record(z.string(), z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthGetMeResponse = z.object({
    data: zBackofficeAdminProfile,
    abilities: z.array(z.enum(['admins.manage']))
});

export const zBackofficeAuthUpdateMeData = z.object({
    body: z.object({
        data: z.object({
            name: z.optional(z.string().min(1).max(100))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthUpdateMeResponse = z.object({
    data: zBackofficeAdminProfile
});

export const zBackofficeAuthGetSessionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthGetSessionResponse = z.object({
    sessionType: z.enum(['unauthenticated', 'authenticated']),
    csrfToken: z.union([
        z.string(),
        z.null()
    ]),
    session: z.union([
        z.object({
            expiresAt: zInstantOutput,
            lastActivityAt: zInstantOutput,
            creationSource: z.string()
        }),
        z.null()
    ]),
    admin: z.union([
        z.object({
            id: z.string()
        }),
        z.null()
    ]),
    abilities: z.union([
        z.array(z.enum(['admins.manage'])),
        z.null()
    ])
});

export const zBackofficeAuthSignOutData = z.object({
    body: z.object({
        token: z.optional(z.string().min(1))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zBackofficeAuthSignOutResponse = z.object({
    status: z.enum(['success'])
});

export const zPoListRunsData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.optional(z.object({
            search: z.optional(z.string().max(200)),
            status: z.optional(z.array(z.enum([
                'pending',
                'running',
                'failed',
                'in_progress',
                'completed',
                'archived'
            ])).max(10))
        })),
        sort: z.optional(z.object({
            by: z.optional(z.enum([
                'name',
                'campaign',
                'status',
                'createdAt',
                'updatedAt'
            ])),
            direction: z.optional(z.enum(['asc', 'desc']))
        }))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoListRunsResponse = z.object({
    data: z.array(zPoRun),
    meta: zOffsetPaginationMeta
});

export const zPoCreateRunData = z.object({
    body: z.object({
        data: z.object({
            name: z.optional(z.string().min(1).max(256)),
            mode: z.optional(z.enum(['campagna', 'riordino'])),
            horizonDays: z.optional(z.int().gte(1).lte(365)),
            zeroStock: z.optional(z.boolean()).default(false),
            distributorNames: z.optional(z.array(z.string().min(1)).min(1).max(100))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoCreateRunResponse = z.object({
    data: zPoRun
});

export const zPoGetRunsData = z.object({
    body: z.object({
        filters: z.object({
            ids: z.array(z.string()).min(1).max(100)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoGetRunsResponse = z.object({
    data: z.array(z.object({
        id: z.string(),
        name: z.string(),
        campaign: z.int().gte(-9007199254740991).lte(9007199254740991),
        mode: z.enum(['campagna', 'riordino']),
        horizonDays: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        zeroStock: z.boolean(),
        distributorNames: z.union([
            z.array(z.string()),
            z.null()
        ]),
        status: z.enum([
            'pending',
            'running',
            'failed',
            'in_progress',
            'completed',
            'archived'
        ]),
        engineVersion: z.union([
            z.string(),
            z.null()
        ]),
        error: z.union([
            z.string(),
            z.null()
        ]),
        totalRows: z.int().gte(-9007199254740991).lte(9007199254740991),
        orderedRows: z.int().gte(-9007199254740991).lte(9007199254740991),
        totalCopies: z.int().gte(-9007199254740991).lte(9007199254740991),
        reviewedRows: z.int().gte(-9007199254740991).lte(9007199254740991),
        flaggedRows: z.int().gte(-9007199254740991).lte(9007199254740991),
        adottatoLoaded: z.union([
            z.boolean(),
            z.null()
        ]),
        segnaliAssenti: z.union([
            z.array(z.string()),
            z.null()
        ]),
        datasetAsOf: z.union([
            z.string(),
            z.null()
        ]),
        tablesBehind: z.union([
            z.array(zDatasetTableBehind),
            z.null()
        ]),
        startedAt: z.union([
            z.string(),
            z.null()
        ]),
        finishedAt: z.union([
            z.string(),
            z.null()
        ]),
        createdAt: zInstantOutput,
        updatedAt: zInstantOutput,
        publishers: z.array(zPoPublisherTab),
        distributors: z.array(zPoDistributorTab)
    }))
});

export const zPoRenameRunData = z.object({
    body: z.object({
        data: z.object({
            id: z.string(),
            name: z.string().min(1).max(256)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoRenameRunResponse = z.object({
    data: zPoRun
});

export const zPoUpdateRunStatusData = z.object({
    body: z.object({
        data: z.object({
            id: z.string(),
            status: z.enum(['completed', 'archived'])
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoUpdateRunStatusResponse = z.object({
    data: zPoRun
});

export const zPoListProposalsData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.object({
            publisherIds: z.optional(z.array(z.int().gte(-2147483648).lte(2147483647)).max(100)),
            distributorNames: z.optional(z.array(z.string()).max(100)),
            schoolTypes: z.optional(z.array(z.enum([
                'elementari',
                'medie',
                'superiori',
                'varia'
            ])).max(10)),
            flags: z.optional(z.array(z.enum([
                'VERIFICA_EDIZIONE',
                'ESCLUSIVA_PERSA',
                'ESCLUSIVA_ACQUISITA',
                'SCORRIMENTO',
                'ADOTTATO',
                'EDIZIONE_RECENTE',
                'COPERTO',
                'EDIZIONE_DOPPIA',
                'CAPO_CICLO',
                'PRIMO_VOLUME',
                'NON_USCITO',
                ''
            ])).max(20)),
            reviewStatus: z.optional(z.array(z.enum([
                'pending',
                'accepted',
                'corrected'
            ])).max(10)),
            search: z.optional(z.string().max(200)),
            onlyOrdered: z.optional(z.boolean()),
            runId: z.string()
        }),
        sort: z.optional(z.object({
            field: z.enum([
                'priority',
                'title',
                'publisherName',
                'proposedQty',
                'soldPrevYear',
                'predSoldPrevYear',
                'forecast',
                'stock',
                'stockReal',
                'correctedQty',
                'adoptions'
            ]),
            direction: z.enum(['asc', 'desc'])
        }))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoListProposalsResponse = z.object({
    data: z.array(zPoProposalGridRow),
    meta: zOffsetPaginationMeta
});

export const zPoGetProposalsData = z.object({
    body: z.object({
        filters: z.object({
            ids: z.array(z.string()).min(1).max(100)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoGetProposalsResponse = z.object({
    data: z.array(z.object({
        id: z.string(),
        runId: z.string(),
        campaign: z.int().gte(-9007199254740991).lte(9007199254740991),
        libro: z.int().gte(-9007199254740991).lte(9007199254740991),
        bookCode: z.union([
            z.string(),
            z.null()
        ]),
        title: z.union([
            z.string(),
            z.null()
        ]),
        isbn: z.union([
            z.string(),
            z.null()
        ]),
        publisherId: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        publisherName: z.union([
            z.string(),
            z.null()
        ]),
        distributorName: z.union([
            z.string(),
            z.null()
        ]),
        schoolType: z.string(),
        proposedQty: z.int().gte(-9007199254740991).lte(9007199254740991),
        reasoning: z.string(),
        flag: z.string(),
        forecast: z.int().gte(-9007199254740991).lte(9007199254740991),
        soldPrevYear: z.int().gte(-9007199254740991).lte(9007199254740991),
        soldYtd: z.int().gte(-9007199254740991).lte(9007199254740991),
        predSoldPrevYear: z.int().gte(-9007199254740991).lte(9007199254740991),
        predSoldYtd: z.int().gte(-9007199254740991).lte(9007199254740991),
        stock: z.int().gte(-9007199254740991).lte(9007199254740991),
        committed: z.int().gte(-9007199254740991).lte(9007199254740991),
        orderedYtd: z.int().gte(-9007199254740991).lte(9007199254740991),
        orderValue: z.number(),
        reviewStatus: z.enum([
            'pending',
            'accepted',
            'corrected'
        ]),
        correctedQty: z.union([
            z.int().gte(-9007199254740991).lte(9007199254740991),
            z.null()
        ]),
        feedbackNote: z.union([
            z.string(),
            z.null()
        ]),
        reviewedAt: z.union([
            z.string(),
            z.null()
        ]),
        details: z.unknown(),
        pastDecisions: z.array(zPoPastDecision)
    }))
});

export const zPoAcceptProposalData = z.object({
    body: z.object({
        data: z.object({
            id: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoAcceptProposalResponse = z.object({
    data: zPoProposal
});

export const zPoCorrectProposalData = z.object({
    body: z.object({
        data: z.object({
            id: z.string(),
            correctedQty: z.int().gte(0).lte(1000000),
            note: z.string().min(1).max(5000)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoCorrectProposalResponse = z.object({
    data: zPoProposal
});

export const zPoBulkAcceptProposalsData = z.object({
    body: z.object({
        data: z.object({
            runId: z.string(),
            ids: z.optional(z.array(z.string()).min(1).max(10000)),
            all: z.optional(z.boolean()).default(false),
            filters: z.optional(zPoProposalViewFilters)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoBulkAcceptProposalsResponse = z.object({
    status: z.enum(['success']),
    accepted: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zPoGetProposalHistoryData = z.object({
    body: z.object({
        filters: z.object({
            id: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoGetProposalHistoryResponse = z.object({
    data: z.array(zPoAuditEvent)
});

export const zPoListDistributorsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoListDistributorsResponse = z.object({
    data: z.array(z.object({
        name: z.string()
    }))
});

export const zPoListPublishersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoListPublishersResponse = z.object({
    data: z.array(z.object({
        name: z.string(),
        soldPrevYear: z.number()
    }))
});

export const zPoCreateExportData = z.object({
    body: z.object({
        data: z.object({
            runId: z.string(),
            publisherIds: z.optional(z.array(z.int().gte(-2147483648).lte(2147483647)).max(500)),
            distributorNames: z.optional(z.array(z.string()).max(100)),
            schoolTypes: z.optional(z.array(z.enum([
                'elementari',
                'medie',
                'superiori',
                'varia'
            ])).max(10)),
            reviewStatus: z.optional(z.array(z.enum([
                'pending',
                'accepted',
                'corrected'
            ])).max(10)),
            search: z.optional(z.string().max(200))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoCreateExportResponse = z.object({
    data: zPoExport
});

export const zPoListExportsData = z.object({
    body: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        filters: z.optional(z.object({
            runId: z.optional(z.string()),
            status: z.optional(z.array(z.enum([
                'pending',
                'completed',
                'failed'
            ])))
        })),
        sort: z.optional(z.object({
            by: z.optional(z.enum(['generatedAt', 'createdAt'])),
            direction: z.optional(z.enum(['asc', 'desc']))
        }))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoListExportsResponse = z.object({
    data: z.array(zPoExport),
    meta: zOffsetPaginationMeta
});

export const zPoGetExportDownloadData = z.object({
    body: z.object({
        filters: z.object({
            id: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoGetExportDownloadResponse = z.object({
    data: z.object({
        xlsxUrl: z.union([
            z.string(),
            z.null()
        ]),
        csvUrl: z.union([
            z.string(),
            z.null()
        ]),
        expiresInSeconds: z.int().gte(-9007199254740991).lte(9007199254740991)
    })
});

export const zPoGetConfigData = z.object({
    body: z.object({
        includeHistory: z.optional(z.boolean())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoGetConfigResponse = z.object({
    data: z.object({
        config: z.object({
            esclusiveByYear: z.array(zExclusivitySnapshot).max(1000).default([]),
            esclusive: z.array(z.object({
                name: z.string().min(1),
                returnPct: z.union([
                    z.number().gte(0).lte(1),
                    z.null()
                ]),
                regions: z.array(z.enum([
                    'LAZIO',
                    'CAMPANIA',
                    'SICILIA',
                    'PUGLIA',
                    'TOSCANA',
                    'CALABRIA',
                    'SARDEGNA',
                    'ABRUZZO',
                    'UMBRIA',
                    'BASILICATA',
                    'MOLISE'
                ]))
            })),
            esclusiveChanges: z.array(z.object({
                name: z.string().min(1),
                change: z.enum(['lost', 'gained']),
                campaign: z.int().gte(-9007199254740991).lte(9007199254740991)
            })).default([{
                    name: 'ATLAS',
                    change: 'lost',
                    campaign: 2026
                }]),
            safetyDefault: z.number().gte(0).lte(1),
            safetyEsclusiva: z.number().gte(0).lte(1),
            agentSyncHours: z.array(z.int().gte(0).lte(23)),
            tuning: z.object({
                fitMinBase: z.number().gte(0).default(20),
                retentionDefaults: z.tuple([
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0)
                ]).default([
                    1.05,
                    1.1,
                    1,
                    0.8,
                    0.73,
                    0.73,
                    0.72,
                    0.7,
                    0.66,
                    0.68,
                    0.7
                ]),
                retMature: z.number().gte(0).default(0.7),
                retFloor: z.number().gte(0).default(0.55),
                retCeil: z.number().gte(0).default(1.2),
                segMinVol: z.number().gte(0).default(30000),
                segClipLow: z.number().gte(0).default(0.75),
                segClipHigh: z.number().gte(0).default(1.3),
                blendK: z.number().gte(0).default(1.3),
                blendMinElapsed: z.number().gte(0).lte(1).default(0.08),
                ytdFloorCap: z.number().gte(0).default(2),
                reorderHorizonDays: z.int().gte(1).lte(365).default(14),
                leadTimeDays: z.int().gte(0).lte(9007199254740991).default(10),
                campaignAnticipoShare: z.number().gte(0).lte(1).default(1),
                reorderNewTitleShare: z.number().gte(0).lte(1).default(0.5),
                scorrimentoRecoverMin: z.number().gte(0).default(50),
                scorrimentoMaxOwn: z.number().gte(0).default(50),
                scorrimentoDominance: z.number().gte(0).default(2.5),
                scorrimentoDeadShare: z.number().gte(0).lte(1).default(0.05),
                adottatoHistoryThreshold: z.number().gte(0).default(50),
                adoptionRegionWeighting: z.boolean().default(true),
                adoptionWeightMin: z.number().gte(0).lte(1).default(0.1),
                adoptionWeightMax: z.number().gte(1).default(5),
                exclusivityFactorMin: z.number().gte(0).lte(1).default(0.1),
                exclusivityFactorMax: z.number().gte(1).default(3),
                adoptionCellPrior: z.number().gte(0).default(100),
                adoptionBookingCap: z.number().gte(0).default(8),
                adoptionBookingMin: z.number().gte(0).default(20),
                succDeclineFromMin: z.number().gte(0).default(80),
                succCollapseRatio: z.number().gte(0).lte(1).default(0.4),
                succActiveMin: z.number().gte(0).default(50),
                succSimMin: z.number().gte(0).lte(1).default(0.7),
                coexistMinYearGap: z.int().gte(0).lte(9007199254740991).default(3),
                universeExcludePublishers: z.array(z.string()).default(['SERVIZI', 'AFFITTI']),
                edizioneRecenteMaxAge: z.number().gte(0).default(1),
                edizioneRecenteMinVol: z.number().gte(0).default(100),
                lotExactBelow: z.number().gte(0).default(5),
                lotMinRecurring: z.number().gte(0).default(5),
                lotSteps: z.array(z.object({
                    upTo: z.union([
                        z.int().gt(0).lte(9007199254740991),
                        z.null()
                    ]),
                    step: z.int().gt(0).lte(9007199254740991)
                })).min(1).default([
                    { upTo: 50, step: 5 },
                    { upTo: 200, step: 25 },
                    { upTo: 1000, step: 50 },
                    { upTo: null, step: 100 }
                ])
            }).default({
                fitMinBase: 20,
                retentionDefaults: [
                    1.05,
                    1.1,
                    1,
                    0.8,
                    0.73,
                    0.73,
                    0.72,
                    0.7,
                    0.66,
                    0.68,
                    0.7
                ],
                retMature: 0.7,
                retFloor: 0.55,
                retCeil: 1.2,
                segMinVol: 30000,
                segClipLow: 0.75,
                segClipHigh: 1.3,
                blendK: 1.3,
                blendMinElapsed: 0.08,
                ytdFloorCap: 2,
                reorderHorizonDays: 14,
                leadTimeDays: 10,
                campaignAnticipoShare: 1,
                reorderNewTitleShare: 0.5,
                scorrimentoRecoverMin: 50,
                scorrimentoMaxOwn: 50,
                scorrimentoDominance: 2.5,
                scorrimentoDeadShare: 0.05,
                adottatoHistoryThreshold: 50,
                adoptionRegionWeighting: true,
                adoptionWeightMin: 0.1,
                adoptionWeightMax: 5,
                exclusivityFactorMin: 0.1,
                exclusivityFactorMax: 3,
                adoptionCellPrior: 100,
                adoptionBookingCap: 8,
                adoptionBookingMin: 20,
                succDeclineFromMin: 80,
                succCollapseRatio: 0.4,
                succActiveMin: 50,
                succSimMin: 0.7,
                coexistMinYearGap: 3,
                universeExcludePublishers: ['SERVIZI', 'AFFITTI'],
                edizioneRecenteMaxAge: 1,
                edizioneRecenteMinVol: 100,
                lotExactBelow: 5,
                lotMinRecurring: 5,
                lotSteps: [
                    { upTo: 50, step: 5 },
                    { upTo: 200, step: 25 },
                    { upTo: 1000, step: 50 },
                    { upTo: null, step: 100 }
                ]
            })
        }),
        history: z.array(zPoConfigHistoryEntry)
    })
});

export const zPoUpdateConfigData = z.object({
    body: z.object({
        data: z.object({
            config: z.object({
                esclusiveByYear: z.optional(z.array(zExclusivitySnapshot).max(1000)).default([]),
                esclusive: z.array(z.object({
                    name: z.string().min(1),
                    returnPct: z.union([
                        z.number().gte(0).lte(1),
                        z.null()
                    ]),
                    regions: z.array(z.enum([
                        'LAZIO',
                        'CAMPANIA',
                        'SICILIA',
                        'PUGLIA',
                        'TOSCANA',
                        'CALABRIA',
                        'SARDEGNA',
                        'ABRUZZO',
                        'UMBRIA',
                        'BASILICATA',
                        'MOLISE'
                    ]))
                })),
                esclusiveChanges: z.optional(z.array(z.object({
                    name: z.string().min(1),
                    change: z.enum(['lost', 'gained']),
                    campaign: z.int().gte(-9007199254740991).lte(9007199254740991)
                }))).default([{
                        name: 'ATLAS',
                        change: 'lost',
                        campaign: 2026
                    }]),
                safetyDefault: z.number().gte(0).lte(1),
                safetyEsclusiva: z.number().gte(0).lte(1),
                agentSyncHours: z.array(z.int().gte(0).lte(23)),
                tuning: z.optional(z.object({
                    fitMinBase: z.optional(z.number().gte(0)).default(20),
                    retentionDefaults: z.optional(z.tuple([
                        z.number().gte(0),
                        z.number().gte(0),
                        z.number().gte(0),
                        z.number().gte(0),
                        z.number().gte(0),
                        z.number().gte(0),
                        z.number().gte(0),
                        z.number().gte(0),
                        z.number().gte(0),
                        z.number().gte(0),
                        z.number().gte(0)
                    ])).default([
                        1.05,
                        1.1,
                        1,
                        0.8,
                        0.73,
                        0.73,
                        0.72,
                        0.7,
                        0.66,
                        0.68,
                        0.7
                    ]),
                    retMature: z.optional(z.number().gte(0)).default(0.7),
                    retFloor: z.optional(z.number().gte(0)).default(0.55),
                    retCeil: z.optional(z.number().gte(0)).default(1.2),
                    segMinVol: z.optional(z.number().gte(0)).default(30000),
                    segClipLow: z.optional(z.number().gte(0)).default(0.75),
                    segClipHigh: z.optional(z.number().gte(0)).default(1.3),
                    blendK: z.optional(z.number().gte(0)).default(1.3),
                    blendMinElapsed: z.optional(z.number().gte(0).lte(1)).default(0.08),
                    ytdFloorCap: z.optional(z.number().gte(0)).default(2),
                    reorderHorizonDays: z.optional(z.int().gte(1).lte(365)).default(14),
                    leadTimeDays: z.optional(z.int().gte(0).lte(9007199254740991)).default(10),
                    campaignAnticipoShare: z.optional(z.number().gte(0).lte(1)).default(1),
                    reorderNewTitleShare: z.optional(z.number().gte(0).lte(1)).default(0.5),
                    scorrimentoRecoverMin: z.optional(z.number().gte(0)).default(50),
                    scorrimentoMaxOwn: z.optional(z.number().gte(0)).default(50),
                    scorrimentoDominance: z.optional(z.number().gte(0)).default(2.5),
                    scorrimentoDeadShare: z.optional(z.number().gte(0).lte(1)).default(0.05),
                    adottatoHistoryThreshold: z.optional(z.number().gte(0)).default(50),
                    adoptionRegionWeighting: z.optional(z.boolean()).default(true),
                    adoptionWeightMin: z.optional(z.number().gte(0).lte(1)).default(0.1),
                    adoptionWeightMax: z.optional(z.number().gte(1)).default(5),
                    exclusivityFactorMin: z.optional(z.number().gte(0).lte(1)).default(0.1),
                    exclusivityFactorMax: z.optional(z.number().gte(1)).default(3),
                    adoptionCellPrior: z.optional(z.number().gte(0)).default(100),
                    adoptionBookingCap: z.optional(z.number().gte(0)).default(8),
                    adoptionBookingMin: z.optional(z.number().gte(0)).default(20),
                    succDeclineFromMin: z.optional(z.number().gte(0)).default(80),
                    succCollapseRatio: z.optional(z.number().gte(0).lte(1)).default(0.4),
                    succActiveMin: z.optional(z.number().gte(0)).default(50),
                    succSimMin: z.optional(z.number().gte(0).lte(1)).default(0.7),
                    coexistMinYearGap: z.optional(z.int().gte(0).lte(9007199254740991)).default(3),
                    universeExcludePublishers: z.optional(z.array(z.string())).default(['SERVIZI', 'AFFITTI']),
                    edizioneRecenteMaxAge: z.optional(z.number().gte(0)).default(1),
                    edizioneRecenteMinVol: z.optional(z.number().gte(0)).default(100),
                    lotExactBelow: z.optional(z.number().gte(0)).default(5),
                    lotMinRecurring: z.optional(z.number().gte(0)).default(5),
                    lotSteps: z.optional(z.array(z.object({
                        upTo: z.union([
                            z.int().gt(0).lte(9007199254740991),
                            z.null()
                        ]),
                        step: z.int().gt(0).lte(9007199254740991)
                    })).min(1)).default([
                        { upTo: 50, step: 5 },
                        { upTo: 200, step: 25 },
                        { upTo: 1000, step: 50 },
                        { upTo: null, step: 100 }
                    ])
                })).default({
                    fitMinBase: 20,
                    retentionDefaults: [
                        1.05,
                        1.1,
                        1,
                        0.8,
                        0.73,
                        0.73,
                        0.72,
                        0.7,
                        0.66,
                        0.68,
                        0.7
                    ],
                    retMature: 0.7,
                    retFloor: 0.55,
                    retCeil: 1.2,
                    segMinVol: 30000,
                    segClipLow: 0.75,
                    segClipHigh: 1.3,
                    blendK: 1.3,
                    blendMinElapsed: 0.08,
                    ytdFloorCap: 2,
                    reorderHorizonDays: 14,
                    leadTimeDays: 10,
                    campaignAnticipoShare: 1,
                    reorderNewTitleShare: 0.5,
                    scorrimentoRecoverMin: 50,
                    scorrimentoMaxOwn: 50,
                    scorrimentoDominance: 2.5,
                    scorrimentoDeadShare: 0.05,
                    adottatoHistoryThreshold: 50,
                    adoptionRegionWeighting: true,
                    adoptionWeightMin: 0.1,
                    adoptionWeightMax: 5,
                    exclusivityFactorMin: 0.1,
                    exclusivityFactorMax: 3,
                    adoptionCellPrior: 100,
                    adoptionBookingCap: 8,
                    adoptionBookingMin: 20,
                    succDeclineFromMin: 80,
                    succCollapseRatio: 0.4,
                    succActiveMin: 50,
                    succSimMin: 0.7,
                    coexistMinYearGap: 3,
                    universeExcludePublishers: ['SERVIZI', 'AFFITTI'],
                    edizioneRecenteMaxAge: 1,
                    edizioneRecenteMinVol: 100,
                    lotExactBelow: 5,
                    lotMinRecurring: 5,
                    lotSteps: [
                        { upTo: 50, step: 5 },
                        { upTo: 200, step: 25 },
                        { upTo: 1000, step: 50 },
                        { upTo: null, step: 100 }
                    ]
                })
            })
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoUpdateConfigResponse = z.object({
    data: z.object({
        config: z.object({
            esclusiveByYear: z.array(zExclusivitySnapshot).max(1000).default([]),
            esclusive: z.array(z.object({
                name: z.string().min(1),
                returnPct: z.union([
                    z.number().gte(0).lte(1),
                    z.null()
                ]),
                regions: z.array(z.enum([
                    'LAZIO',
                    'CAMPANIA',
                    'SICILIA',
                    'PUGLIA',
                    'TOSCANA',
                    'CALABRIA',
                    'SARDEGNA',
                    'ABRUZZO',
                    'UMBRIA',
                    'BASILICATA',
                    'MOLISE'
                ]))
            })),
            esclusiveChanges: z.array(z.object({
                name: z.string().min(1),
                change: z.enum(['lost', 'gained']),
                campaign: z.int().gte(-9007199254740991).lte(9007199254740991)
            })).default([{
                    name: 'ATLAS',
                    change: 'lost',
                    campaign: 2026
                }]),
            safetyDefault: z.number().gte(0).lte(1),
            safetyEsclusiva: z.number().gte(0).lte(1),
            agentSyncHours: z.array(z.int().gte(0).lte(23)),
            tuning: z.object({
                fitMinBase: z.number().gte(0).default(20),
                retentionDefaults: z.tuple([
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0)
                ]).default([
                    1.05,
                    1.1,
                    1,
                    0.8,
                    0.73,
                    0.73,
                    0.72,
                    0.7,
                    0.66,
                    0.68,
                    0.7
                ]),
                retMature: z.number().gte(0).default(0.7),
                retFloor: z.number().gte(0).default(0.55),
                retCeil: z.number().gte(0).default(1.2),
                segMinVol: z.number().gte(0).default(30000),
                segClipLow: z.number().gte(0).default(0.75),
                segClipHigh: z.number().gte(0).default(1.3),
                blendK: z.number().gte(0).default(1.3),
                blendMinElapsed: z.number().gte(0).lte(1).default(0.08),
                ytdFloorCap: z.number().gte(0).default(2),
                reorderHorizonDays: z.int().gte(1).lte(365).default(14),
                leadTimeDays: z.int().gte(0).lte(9007199254740991).default(10),
                campaignAnticipoShare: z.number().gte(0).lte(1).default(1),
                reorderNewTitleShare: z.number().gte(0).lte(1).default(0.5),
                scorrimentoRecoverMin: z.number().gte(0).default(50),
                scorrimentoMaxOwn: z.number().gte(0).default(50),
                scorrimentoDominance: z.number().gte(0).default(2.5),
                scorrimentoDeadShare: z.number().gte(0).lte(1).default(0.05),
                adottatoHistoryThreshold: z.number().gte(0).default(50),
                adoptionRegionWeighting: z.boolean().default(true),
                adoptionWeightMin: z.number().gte(0).lte(1).default(0.1),
                adoptionWeightMax: z.number().gte(1).default(5),
                exclusivityFactorMin: z.number().gte(0).lte(1).default(0.1),
                exclusivityFactorMax: z.number().gte(1).default(3),
                adoptionCellPrior: z.number().gte(0).default(100),
                adoptionBookingCap: z.number().gte(0).default(8),
                adoptionBookingMin: z.number().gte(0).default(20),
                succDeclineFromMin: z.number().gte(0).default(80),
                succCollapseRatio: z.number().gte(0).lte(1).default(0.4),
                succActiveMin: z.number().gte(0).default(50),
                succSimMin: z.number().gte(0).lte(1).default(0.7),
                coexistMinYearGap: z.int().gte(0).lte(9007199254740991).default(3),
                universeExcludePublishers: z.array(z.string()).default(['SERVIZI', 'AFFITTI']),
                edizioneRecenteMaxAge: z.number().gte(0).default(1),
                edizioneRecenteMinVol: z.number().gte(0).default(100),
                lotExactBelow: z.number().gte(0).default(5),
                lotMinRecurring: z.number().gte(0).default(5),
                lotSteps: z.array(z.object({
                    upTo: z.union([
                        z.int().gt(0).lte(9007199254740991),
                        z.null()
                    ]),
                    step: z.int().gt(0).lte(9007199254740991)
                })).min(1).default([
                    { upTo: 50, step: 5 },
                    { upTo: 200, step: 25 },
                    { upTo: 1000, step: 50 },
                    { upTo: null, step: 100 }
                ])
            }).default({
                fitMinBase: 20,
                retentionDefaults: [
                    1.05,
                    1.1,
                    1,
                    0.8,
                    0.73,
                    0.73,
                    0.72,
                    0.7,
                    0.66,
                    0.68,
                    0.7
                ],
                retMature: 0.7,
                retFloor: 0.55,
                retCeil: 1.2,
                segMinVol: 30000,
                segClipLow: 0.75,
                segClipHigh: 1.3,
                blendK: 1.3,
                blendMinElapsed: 0.08,
                ytdFloorCap: 2,
                reorderHorizonDays: 14,
                leadTimeDays: 10,
                campaignAnticipoShare: 1,
                reorderNewTitleShare: 0.5,
                scorrimentoRecoverMin: 50,
                scorrimentoMaxOwn: 50,
                scorrimentoDominance: 2.5,
                scorrimentoDeadShare: 0.05,
                adottatoHistoryThreshold: 50,
                adoptionRegionWeighting: true,
                adoptionWeightMin: 0.1,
                adoptionWeightMax: 5,
                exclusivityFactorMin: 0.1,
                exclusivityFactorMax: 3,
                adoptionCellPrior: 100,
                adoptionBookingCap: 8,
                adoptionBookingMin: 20,
                succDeclineFromMin: 80,
                succCollapseRatio: 0.4,
                succActiveMin: 50,
                succSimMin: 0.7,
                coexistMinYearGap: 3,
                universeExcludePublishers: ['SERVIZI', 'AFFITTI'],
                edizioneRecenteMaxAge: 1,
                edizioneRecenteMinVol: 100,
                lotExactBelow: 5,
                lotMinRecurring: 5,
                lotSteps: [
                    { upTo: 50, step: 5 },
                    { upTo: 200, step: 25 },
                    { upTo: 1000, step: 50 },
                    { upTo: null, step: 100 }
                ]
            })
        })
    })
});

export const zPoCreateExclusivityYearData = z.object({
    body: z.object({
        data: z.object({
            year: z.int().gte(1900).lte(9999),
            copyFromYear: z.int().gte(1900).lte(9999)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoCreateExclusivityYearResponse = z.object({
    data: z.object({
        config: z.object({
            esclusiveByYear: z.array(zExclusivitySnapshot).max(1000).default([]),
            esclusive: z.array(z.object({
                name: z.string().min(1),
                returnPct: z.union([
                    z.number().gte(0).lte(1),
                    z.null()
                ]),
                regions: z.array(z.enum([
                    'LAZIO',
                    'CAMPANIA',
                    'SICILIA',
                    'PUGLIA',
                    'TOSCANA',
                    'CALABRIA',
                    'SARDEGNA',
                    'ABRUZZO',
                    'UMBRIA',
                    'BASILICATA',
                    'MOLISE'
                ]))
            })),
            esclusiveChanges: z.array(z.object({
                name: z.string().min(1),
                change: z.enum(['lost', 'gained']),
                campaign: z.int().gte(-9007199254740991).lte(9007199254740991)
            })).default([{
                    name: 'ATLAS',
                    change: 'lost',
                    campaign: 2026
                }]),
            safetyDefault: z.number().gte(0).lte(1),
            safetyEsclusiva: z.number().gte(0).lte(1),
            agentSyncHours: z.array(z.int().gte(0).lte(23)),
            tuning: z.object({
                fitMinBase: z.number().gte(0).default(20),
                retentionDefaults: z.tuple([
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0)
                ]).default([
                    1.05,
                    1.1,
                    1,
                    0.8,
                    0.73,
                    0.73,
                    0.72,
                    0.7,
                    0.66,
                    0.68,
                    0.7
                ]),
                retMature: z.number().gte(0).default(0.7),
                retFloor: z.number().gte(0).default(0.55),
                retCeil: z.number().gte(0).default(1.2),
                segMinVol: z.number().gte(0).default(30000),
                segClipLow: z.number().gte(0).default(0.75),
                segClipHigh: z.number().gte(0).default(1.3),
                blendK: z.number().gte(0).default(1.3),
                blendMinElapsed: z.number().gte(0).lte(1).default(0.08),
                ytdFloorCap: z.number().gte(0).default(2),
                reorderHorizonDays: z.int().gte(1).lte(365).default(14),
                leadTimeDays: z.int().gte(0).lte(9007199254740991).default(10),
                campaignAnticipoShare: z.number().gte(0).lte(1).default(1),
                reorderNewTitleShare: z.number().gte(0).lte(1).default(0.5),
                scorrimentoRecoverMin: z.number().gte(0).default(50),
                scorrimentoMaxOwn: z.number().gte(0).default(50),
                scorrimentoDominance: z.number().gte(0).default(2.5),
                scorrimentoDeadShare: z.number().gte(0).lte(1).default(0.05),
                adottatoHistoryThreshold: z.number().gte(0).default(50),
                adoptionRegionWeighting: z.boolean().default(true),
                adoptionWeightMin: z.number().gte(0).lte(1).default(0.1),
                adoptionWeightMax: z.number().gte(1).default(5),
                exclusivityFactorMin: z.number().gte(0).lte(1).default(0.1),
                exclusivityFactorMax: z.number().gte(1).default(3),
                adoptionCellPrior: z.number().gte(0).default(100),
                adoptionBookingCap: z.number().gte(0).default(8),
                adoptionBookingMin: z.number().gte(0).default(20),
                succDeclineFromMin: z.number().gte(0).default(80),
                succCollapseRatio: z.number().gte(0).lte(1).default(0.4),
                succActiveMin: z.number().gte(0).default(50),
                succSimMin: z.number().gte(0).lte(1).default(0.7),
                coexistMinYearGap: z.int().gte(0).lte(9007199254740991).default(3),
                universeExcludePublishers: z.array(z.string()).default(['SERVIZI', 'AFFITTI']),
                edizioneRecenteMaxAge: z.number().gte(0).default(1),
                edizioneRecenteMinVol: z.number().gte(0).default(100),
                lotExactBelow: z.number().gte(0).default(5),
                lotMinRecurring: z.number().gte(0).default(5),
                lotSteps: z.array(z.object({
                    upTo: z.union([
                        z.int().gt(0).lte(9007199254740991),
                        z.null()
                    ]),
                    step: z.int().gt(0).lte(9007199254740991)
                })).min(1).default([
                    { upTo: 50, step: 5 },
                    { upTo: 200, step: 25 },
                    { upTo: 1000, step: 50 },
                    { upTo: null, step: 100 }
                ])
            }).default({
                fitMinBase: 20,
                retentionDefaults: [
                    1.05,
                    1.1,
                    1,
                    0.8,
                    0.73,
                    0.73,
                    0.72,
                    0.7,
                    0.66,
                    0.68,
                    0.7
                ],
                retMature: 0.7,
                retFloor: 0.55,
                retCeil: 1.2,
                segMinVol: 30000,
                segClipLow: 0.75,
                segClipHigh: 1.3,
                blendK: 1.3,
                blendMinElapsed: 0.08,
                ytdFloorCap: 2,
                reorderHorizonDays: 14,
                leadTimeDays: 10,
                campaignAnticipoShare: 1,
                reorderNewTitleShare: 0.5,
                scorrimentoRecoverMin: 50,
                scorrimentoMaxOwn: 50,
                scorrimentoDominance: 2.5,
                scorrimentoDeadShare: 0.05,
                adottatoHistoryThreshold: 50,
                adoptionRegionWeighting: true,
                adoptionWeightMin: 0.1,
                adoptionWeightMax: 5,
                exclusivityFactorMin: 0.1,
                exclusivityFactorMax: 3,
                adoptionCellPrior: 100,
                adoptionBookingCap: 8,
                adoptionBookingMin: 20,
                succDeclineFromMin: 80,
                succCollapseRatio: 0.4,
                succActiveMin: 50,
                succSimMin: 0.7,
                coexistMinYearGap: 3,
                universeExcludePublishers: ['SERVIZI', 'AFFITTI'],
                edizioneRecenteMaxAge: 1,
                edizioneRecenteMinVol: 100,
                lotExactBelow: 5,
                lotMinRecurring: 5,
                lotSteps: [
                    { upTo: 50, step: 5 },
                    { upTo: 200, step: 25 },
                    { upTo: 1000, step: 50 },
                    { upTo: null, step: 100 }
                ]
            })
        })
    })
});

export const zPoUpdateExclusivityPublisherData = z.object({
    body: z.object({
        data: z.object({
            name: z.string().min(1).max(256),
            regions: z.array(z.enum([
                'LAZIO',
                'CAMPANIA',
                'SICILIA',
                'PUGLIA',
                'TOSCANA',
                'CALABRIA',
                'SARDEGNA',
                'ABRUZZO',
                'UMBRIA',
                'BASILICATA',
                'MOLISE'
            ])).max(11),
            returnPct: z.optional(z.union([
                z.number().gte(0).lte(1),
                z.null()
            ])),
            year: z.int().gte(1900).lte(9999)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoUpdateExclusivityPublisherResponse = z.object({
    data: z.object({
        config: z.object({
            esclusiveByYear: z.array(zExclusivitySnapshot).max(1000).default([]),
            esclusive: z.array(z.object({
                name: z.string().min(1),
                returnPct: z.union([
                    z.number().gte(0).lte(1),
                    z.null()
                ]),
                regions: z.array(z.enum([
                    'LAZIO',
                    'CAMPANIA',
                    'SICILIA',
                    'PUGLIA',
                    'TOSCANA',
                    'CALABRIA',
                    'SARDEGNA',
                    'ABRUZZO',
                    'UMBRIA',
                    'BASILICATA',
                    'MOLISE'
                ]))
            })),
            esclusiveChanges: z.array(z.object({
                name: z.string().min(1),
                change: z.enum(['lost', 'gained']),
                campaign: z.int().gte(-9007199254740991).lte(9007199254740991)
            })).default([{
                    name: 'ATLAS',
                    change: 'lost',
                    campaign: 2026
                }]),
            safetyDefault: z.number().gte(0).lte(1),
            safetyEsclusiva: z.number().gte(0).lte(1),
            agentSyncHours: z.array(z.int().gte(0).lte(23)),
            tuning: z.object({
                fitMinBase: z.number().gte(0).default(20),
                retentionDefaults: z.tuple([
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0),
                    z.number().gte(0)
                ]).default([
                    1.05,
                    1.1,
                    1,
                    0.8,
                    0.73,
                    0.73,
                    0.72,
                    0.7,
                    0.66,
                    0.68,
                    0.7
                ]),
                retMature: z.number().gte(0).default(0.7),
                retFloor: z.number().gte(0).default(0.55),
                retCeil: z.number().gte(0).default(1.2),
                segMinVol: z.number().gte(0).default(30000),
                segClipLow: z.number().gte(0).default(0.75),
                segClipHigh: z.number().gte(0).default(1.3),
                blendK: z.number().gte(0).default(1.3),
                blendMinElapsed: z.number().gte(0).lte(1).default(0.08),
                ytdFloorCap: z.number().gte(0).default(2),
                reorderHorizonDays: z.int().gte(1).lte(365).default(14),
                leadTimeDays: z.int().gte(0).lte(9007199254740991).default(10),
                campaignAnticipoShare: z.number().gte(0).lte(1).default(1),
                reorderNewTitleShare: z.number().gte(0).lte(1).default(0.5),
                scorrimentoRecoverMin: z.number().gte(0).default(50),
                scorrimentoMaxOwn: z.number().gte(0).default(50),
                scorrimentoDominance: z.number().gte(0).default(2.5),
                scorrimentoDeadShare: z.number().gte(0).lte(1).default(0.05),
                adottatoHistoryThreshold: z.number().gte(0).default(50),
                adoptionRegionWeighting: z.boolean().default(true),
                adoptionWeightMin: z.number().gte(0).lte(1).default(0.1),
                adoptionWeightMax: z.number().gte(1).default(5),
                exclusivityFactorMin: z.number().gte(0).lte(1).default(0.1),
                exclusivityFactorMax: z.number().gte(1).default(3),
                adoptionCellPrior: z.number().gte(0).default(100),
                adoptionBookingCap: z.number().gte(0).default(8),
                adoptionBookingMin: z.number().gte(0).default(20),
                succDeclineFromMin: z.number().gte(0).default(80),
                succCollapseRatio: z.number().gte(0).lte(1).default(0.4),
                succActiveMin: z.number().gte(0).default(50),
                succSimMin: z.number().gte(0).lte(1).default(0.7),
                coexistMinYearGap: z.int().gte(0).lte(9007199254740991).default(3),
                universeExcludePublishers: z.array(z.string()).default(['SERVIZI', 'AFFITTI']),
                edizioneRecenteMaxAge: z.number().gte(0).default(1),
                edizioneRecenteMinVol: z.number().gte(0).default(100),
                lotExactBelow: z.number().gte(0).default(5),
                lotMinRecurring: z.number().gte(0).default(5),
                lotSteps: z.array(z.object({
                    upTo: z.union([
                        z.int().gt(0).lte(9007199254740991),
                        z.null()
                    ]),
                    step: z.int().gt(0).lte(9007199254740991)
                })).min(1).default([
                    { upTo: 50, step: 5 },
                    { upTo: 200, step: 25 },
                    { upTo: 1000, step: 50 },
                    { upTo: null, step: 100 }
                ])
            }).default({
                fitMinBase: 20,
                retentionDefaults: [
                    1.05,
                    1.1,
                    1,
                    0.8,
                    0.73,
                    0.73,
                    0.72,
                    0.7,
                    0.66,
                    0.68,
                    0.7
                ],
                retMature: 0.7,
                retFloor: 0.55,
                retCeil: 1.2,
                segMinVol: 30000,
                segClipLow: 0.75,
                segClipHigh: 1.3,
                blendK: 1.3,
                blendMinElapsed: 0.08,
                ytdFloorCap: 2,
                reorderHorizonDays: 14,
                leadTimeDays: 10,
                campaignAnticipoShare: 1,
                reorderNewTitleShare: 0.5,
                scorrimentoRecoverMin: 50,
                scorrimentoMaxOwn: 50,
                scorrimentoDominance: 2.5,
                scorrimentoDeadShare: 0.05,
                adottatoHistoryThreshold: 50,
                adoptionRegionWeighting: true,
                adoptionWeightMin: 0.1,
                adoptionWeightMax: 5,
                exclusivityFactorMin: 0.1,
                exclusivityFactorMax: 3,
                adoptionCellPrior: 100,
                adoptionBookingCap: 8,
                adoptionBookingMin: 20,
                succDeclineFromMin: 80,
                succCollapseRatio: 0.4,
                succActiveMin: 50,
                succSimMin: 0.7,
                coexistMinYearGap: 3,
                universeExcludePublishers: ['SERVIZI', 'AFFITTI'],
                edizioneRecenteMaxAge: 1,
                edizioneRecenteMinVol: 100,
                lotExactBelow: 5,
                lotMinRecurring: 5,
                lotSteps: [
                    { upTo: 50, step: 5 },
                    { upTo: 200, step: 25 },
                    { upTo: 1000, step: 50 },
                    { upTo: null, step: 100 }
                ]
            })
        })
    })
});

export const zPoGetSystemStatusData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoGetSystemStatusResponse = z.object({
    data: z.object({
        agent: z.union([
            z.object({
                name: z.string(),
                version: z.union([
                    z.string(),
                    z.null()
                ]),
                lastSeenAt: z.union([
                    z.string(),
                    z.null()
                ]),
                lastFullSyncAt: z.union([
                    z.string(),
                    z.null()
                ])
            }),
            z.null()
        ]),
        tables: z.array(z.object({
            tableName: z.string(),
            receivedAt: zInstantOutput,
            sourceMtime: z.union([
                z.string(),
                z.null()
            ]),
            schemaChanged: z.boolean(),
            confirmedAt: zInstantOutput,
            newerVersionPending: z.boolean(),
            lastOutcome: z.nullable(z.enum([
                'stored',
                'already_present',
                'unchanged',
                'failed'
            ])),
            lastFailureReason: z.union([
                z.string(),
                z.null()
            ])
        })),
        dataset: z.object({
            asOf: z.union([
                z.string(),
                z.null()
            ]),
            syncInProgress: z.boolean(),
            syncStartedAt: z.union([
                z.string(),
                z.null()
            ]),
            missingRequired: z.array(z.string()),
            unresolved: z.array(z.string()),
            tablesBehind: z.array(zDatasetTableBehind)
        }),
        lastRun: z.union([
            z.object({
                id: z.string(),
                name: z.string(),
                campaign: z.int().gte(-9007199254740991).lte(9007199254740991),
                status: z.enum([
                    'pending',
                    'running',
                    'failed',
                    'in_progress',
                    'completed',
                    'archived'
                ]),
                finishedAt: z.union([
                    z.string(),
                    z.null()
                ]),
                adottatoLoaded: z.union([
                    z.boolean(),
                    z.null()
                ]),
                titoliUniverso: z.union([
                    z.int().gte(-9007199254740991).lte(9007199254740991),
                    z.null()
                ])
            }),
            z.null()
        ]),
        refresh: z.union([
            z.object({
                status: z.enum([
                    'queued',
                    'syncing',
                    'completed',
                    'incomplete',
                    'stalled'
                ]),
                requestedAt: zInstantOutput,
                completedAt: z.union([
                    z.string(),
                    z.null()
                ])
            }),
            z.null()
        ]),
        engineVersion: z.string()
    })
});

export const zPoRefreshDataData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zPoRefreshDataResponse = z.object({
    status: z.enum(['success']),
    commandId: z.string()
});

export const zHealthCheckData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zHealthCheckResponse = z.enum(['Healthy']);

export const zHealthCheckServicesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});
